import { DEBUG_BUILD } from '../debug-build.js';
import { logger } from '../utils-hoist/logger.js';
import { spanToJSON, spanIsSampled, getRootSpan } from '../utils/spanUtils.js';
/**
 * Print a log message for a started span.
 */

function logSpanStart(span) {
  if (!DEBUG_BUILD) return;
  var {
    description = '< unknown name >',
    op = '< unknown op >',
    parent_span_id: parentSpanId
  } = spanToJSON(span);
  var {
    spanId
  } = span.spanContext();
  var sampled = spanIsSampled(span);
  var rootSpan = getRootSpan(span);
  var isRootSpan = rootSpan === span;
  var header = "[Tracing] Starting ".concat(sampled ? 'sampled' : 'unsampled', " ").concat(isRootSpan ? 'root ' : '', "span");
  var infoParts = ["op: ".concat(op), "name: ".concat(description), "ID: ".concat(spanId)];

  if (parentSpanId) {
    infoParts.push("parent ID: ".concat(parentSpanId));
  }

  if (!isRootSpan) {
    var {
      op: _op,
      description: _description
    } = spanToJSON(rootSpan);
    infoParts.push("root ID: ".concat(rootSpan.spanContext().spanId));

    if (_op) {
      infoParts.push("root op: ".concat(_op));
    }

    if (_description) {
      infoParts.push("root description: ".concat(_description));
    }
  }

  logger.log("".concat(header, "\n  ").concat(infoParts.join('\n  ')));
}
/**
 * Print a log message for an ended span.
 */


function logSpanEnd(span) {
  if (!DEBUG_BUILD) return;
  var {
    description = '< unknown name >',
    op = '< unknown op >'
  } = spanToJSON(span);
  var {
    spanId
  } = span.spanContext();
  var rootSpan = getRootSpan(span);
  var isRootSpan = rootSpan === span;
  var msg = "[Tracing] Finishing \"".concat(op, "\" ").concat(isRootSpan ? 'root ' : '', "span \"").concat(description, "\" with ID ").concat(spanId);
  logger.log(msg);
}

export { logSpanEnd, logSpanStart };